import {
  HomePageWrapper,
  PageTitle,
  PageSubTitle,
  Description,
  IntroduceImg,
  WaringMessage,
  LinkWarpper,
  StyledLink,
} from "./style";

const Home = () => {
  return (
    <HomePageWrapper>
      <PageTitle>Profile Card Maker</PageTitle>
      <PageSubTitle>나만의 프로필 카드 만들어보자!</PageSubTitle>
      <Description>
        정보를 입력해서 나만의 프로필 카드를 만들어보고
        <br /> 로그인을 하여 만든 프로필 카드를 저장도 해봅시다!
      </Description>
      <IntroduceImg
        src={`${process.env.PUBLIC_URL}/images/introduce.jpg`}
        alt="introduce"
      />
      <WaringMessage>
        개인 연습용 프로젝트의 목적으로 제작된 사이트 입니다.
        <br /> 민감한 정보(개인정보 등)를 등록하지 말아주세요
      </WaringMessage>
      <LinkWarpper>
        <StyledLink to={"/maker"}>프로필 카드 만들기</StyledLink>
        <StyledLink to={"/login"}>로그인</StyledLink>
      </LinkWarpper>
    </HomePageWrapper>
  );
};

export default Home;
